import ButtonBig from './ButtonBig';

export default ButtonBig;
